import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Text, ToolbarHeader } from 'components'
import { TaskWithComponent } from './Todo'
import { useTodosWizard, RefetchFn } from 'hooks/useTodosWizard'

export interface TodosProps {
  todos: TaskWithComponent[]
  refetch: RefetchFn
}

export const Todos: React.FC<TodosProps> = ({ todos, refetch }) => {
  const wizard = useTodosWizard({ todos, refetch })
  const navigateTo = useNavigate()

  useEffect(() => {
    if (wizard.incomplete().length > 0) navigateTo(`/todos/${wizard.incomplete()[0].id}`)
  }, [navigateTo, wizard])

  if (wizard.incomplete().length > 0) return null

  return <Box>
    <ToolbarHeader>
      <Text variant="h4">Todo Tasks</Text>
    </ToolbarHeader>

    <Text mt={{ xs: 0, md: 2 }}>Here you will find tasks to help guide you through setting up and maintaining your Ordo meal program.</Text>

    { wizard.todos.length > 0 && wizard.incomplete().length === 0 && <Box mt={4} pb={4} display="flex" flexDirection="column" maxWidth={800}>
      <Text fontWeight="medium" mb={2}>Congratulations! You&apos;ve completed all your assigned tasks.</Text>
    </Box> }

    { wizard.todos.length === 0 && <Box mt={4} pb={4} display="flex" flexDirection="column" maxWidth={800}>
      <Text fontWeight="medium" mb={2}>Nothing to do! You don&apos;t currently have any assigned tasks.</Text>
    </Box> }
  </Box>
}

export default Todos
